"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateManufacturerMasterSchema = exports.createManufacturerMasterSchema = exports.manufacturerMasterShape = void 0;
const zod_1 = require("zod");
exports.manufacturerMasterShape = {
    manufacturerCode: zod_1.z.string().min(1).max(30).optional(),
    /**
     * The 3 characters the pharmacy tax invoice prints in its "Mfr" column. Left out on create it defaults to the first
     * three letters of the name; the user can type another free code here or later on the master. Stored upper case
     * (the service normalises), so lower case is accepted on the way in.
     */
    shortCode: zod_1.z
        .string()
        .trim()
        .regex(/^[A-Za-z0-9]{3}$/, 'Short code must be exactly 3 letters or digits')
        .optional(),
    name: zod_1.z.string().min(1).max(255),
    licenseNumber: zod_1.z.string().max(50).optional(),
    licenseExpiryDate: zod_1.z.coerce.date().optional(),
    gstin: zod_1.z.string().max(20).optional(),
    address: zod_1.z.string().optional(),
    contactEmail: zod_1.z.string().email().max(255).optional(),
    contactPhone: zod_1.z.string().max(20).optional(),
};
exports.createManufacturerMasterSchema = zod_1.z.object(exports.manufacturerMasterShape);
exports.updateManufacturerMasterSchema = exports.createManufacturerMasterSchema.partial();
//# sourceMappingURL=manufacturer-master.schema.js.map